/**
 * Read this carefully!
 *
 * Because all our frontend apps are part of the same project we need to have
 * some sort of code splitting so that not all apps are loaded when one of them is.
 *
 * Therefore we are going to have code chunks for each of our apps:
 * - default (just shows all the apps).
 * - go (the go app).
 * This splitting is done in the controller.
 *
 * We need a controller to decide which of the apps is loaded based on the window
 * location. It will change as we add sites.
 * - controller (very small utility deciding which app is loaded)
 *
 * This way, in the `main` chunk we only have libraries which are common to all
 * our applications.
 */
import "babel-polyfill";
import "url-polyfill";
import React from "react";
import ReactDOM from "react-dom";
import { createConfig } from "sc/config";
import "react-bootstrap";
import "react-redux";
import "react-router";
import "react-router-redux";
import "redux";
import "redux-logger";
import "redux-persist";
import "redux-saga";
import "reselect";
import OnCall from "sc/ui/sites/oncall/index";

ReactDOM.render(
  React.createElement(OnCall, {
    createConfig: createConfig(),
  }),
  document.getElementById("root"),
);



// WEBPACK FOOTER //
// ./src/index.js